import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd, NavigationSkipped } from "@angular/router";
import { filter } from 'rxjs';
import { Navigation } from '../client/components/navigation/navigation';
import { JoinSection } from '../../shared/components/join-section/join-section';
import { FooterSection } from '../../shared/components/footer-section/footer-section';

@Component({
  selector: 'app-public-layout',
  imports: [
    RouterOutlet,
    Navigation,
    JoinSection,
    FooterSection,
  ],
  templateUrl: './public-layout.html',
  styleUrl: './public-layout.scss',
  encapsulation: ViewEncapsulation.None
})
export class PublicLayout implements OnInit  {
  isProjectView: boolean = false;
  isClientRoute: boolean = false;
  currentYear = new Date().getFullYear();

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => {
        return event instanceof NavigationEnd || event instanceof NavigationSkipped;
      }))  
      .subscribe((event: NavigationEnd | NavigationSkipped) => {
        this.isProjectView = event.url.includes('/project');
        this.isClientRoute = event.url.includes('/client');
      });

    // Set initial value
    this.isClientRoute = this.router.url.includes('/client');
  }
}
